
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/tool-bar.kpa`,
      template: `<div class="tool-bar">
        <div class="wrapper">
            <div class="flex-row">
                <dynamic-breadcrumbs></dynamic-breadcrumbs>
                <a if="download" class="download-link" href="{{download.url}}" target="_blank">
                    <span>{{download.name}}.pdf</span><span><i class="fas fa-download"></i></span>
                </a>
            </div>
        </div>
    </div>`,
      style: `tool-bar .tool-bar .wrapper {
  padding-top: 0;
  padding-bottom: 0;
}
tool-bar .tool-bar .wrapper div {
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 3px solid #64c16c;
}
tool-bar .tool-bar .wrapper div .download-link {
  font-weight: 700;
}
tool-bar .tool-bar .wrapper div .download-link span:first-of-type {
  margin-right: 4px;
}
tool-bar .tool-bar .wrapper div .download-link:hover span:first-of-type {
  text-decoration: none;
}
@media (max-width: 700px) {
  tool-bar .tool-bar .wrapper div {
    align-items: space-between;
  }
  tool-bar .tool-bar .wrapper div .download-link {
    font-size: 14px;
  }
}
@media (max-width: 500px) {
  tool-bar .tool-bar .wrapper div {
    align-items: space-between;
  }
  tool-bar .tool-bar .wrapper div .download-link {
    font-size: 1rem;
  }
  tool-bar .tool-bar .wrapper div .download-link span:first-of-type {
    display: none;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        download: (function () {
            switch (window.location.pathname) {
                case '/datenschutzerklaerung':
                    return { name: 'Datenschutzerklärung', url: '/downloads/Datenschutzerklaerung-FASE2.pdf' };
                case '/agbs':
                    return { name: 'AGB', url: '/downloads/AGB-FASE2.pdf' };
                case '/widerrufsbelehrung':
                    return { name: 'Widerrufsbelehrung', url: '/downloads/Widerrufsbelehrung-FASE2.pdf' };
                default:
                    return '';
            }
        })(),
    },
};
 })()`
    };
  